module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('member-form', {
    attrs: {
      "info": _vm.info
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ea7eaed"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Member/UpMember.vue
// module id = 2373
// module chunks = 1